// Client-side "did you mean gmail.com?" suggester for the SPA.
//
// Catches the typos the server can't: gmial.com and its cousins are registered
// domains with working mail servers, so DNS accepts them and they never bounce
// — the verification code just gets delivered to a squatter. Only a human
// recognising "that's not what I meant" fixes it, so we suggest and let them click.
//
// KEEP IN SYNC with EmailSanity::COMMON_DOMAINS in app/lib/email_sanity.rb.
// EmailSanityTest asserts these two lists match, so CI will shout if they drift.
export const COMMON_EMAIL_DOMAINS = [
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'outlook.com',
  'icloud.com',
  'aol.com',
  'live.com',
  'msn.com',
  'comcast.net',
  'verizon.net',
  'me.com',
  'mac.com',
  'protonmail.com',
  'proton.me',
  'gmx.com',
  'ymail.com',
  'googlemail.com',
  'sbcglobal.net',
  'bellsouth.net',
  'charter.net',
  'cox.net',
  'rocketmail.com',
  'mail.com',
  'zoho.com',
  'yandex.com'
]

// 2 catches gmial/gmai/gmal/gnail; 3 starts matching unrelated real domains
// and telling people their perfectly good company address is a mistake.
const MAX_DISTANCE = 2

const distance = (a, b) => {
  const rows = []
  for (let i = 0; i <= b.length; i++) rows[i] = [i]
  for (let j = 0; j <= a.length; j++) rows[0][j] = j
  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      const cost = b.charAt(i - 1) === a.charAt(j - 1) ? 0 : 1
      rows[i][j] = Math.min(rows[i - 1][j] + 1, rows[i][j - 1] + 1, rows[i - 1][j - 1] + cost)
    }
  }
  return rows[b.length][a.length]
}

// Returns a corrected full address, or null when the domain looks intentional.
export const suggestEmail = (value) => {
  const trimmed = (value || '').trim()
  const at = trimmed.lastIndexOf('@')
  if (at < 1) return null

  const local = trimmed.slice(0, at)
  const domain = trimmed.slice(at + 1).toLowerCase()
  if (!domain || COMMON_EMAIL_DOMAINS.includes(domain)) return null

  let best = null
  let bestDistance = Infinity
  COMMON_EMAIL_DOMAINS.forEach((candidate) => {
    const d = distance(domain, candidate)
    if (d < bestDistance) {
      bestDistance = d
      best = candidate
    }
  })

  if (!best || bestDistance === 0 || bestDistance > MAX_DISTANCE) return null
  return `${local}@${best}`
}

export default suggestEmail
